import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const API = '';

function HelpTip({ text }) {
  const [show, setShow] = useState(false);
  return (
    <span style={{position:'relative',display:'inline-block',marginLeft:4}}>
      <span onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}
        style={{display:'inline-flex',alignItems:'center',justifyContent:'center',width:16,height:16,borderRadius:'50%',
          background:'#e0e0e0',color:'#666',fontSize:10,fontWeight:'bold',cursor:'help',userSelect:'none'}}>?</span>
      {show && (
        <div style={{position:'absolute',bottom:'calc(100% + 6px)',left:'50%',transform:'translateX(-50%)',
          background:'#333',color:'white',padding:'8px 12px',borderRadius:6,fontSize:11,lineHeight:1.5,
          whiteSpace:'pre-line',width:240,zIndex:100,boxShadow:'0 4px 12px rgba(0,0,0,0.2)',pointerEvents:'none'}}>
          {text}
          <div style={{position:'absolute',bottom:-5,left:'50%',transform:'translateX(-50%)',width:0,height:0,
            borderLeft:'6px solid transparent',borderRight:'6px solid transparent',borderTop:'6px solid #333'}} />
        </div>
      )}
    </span>
  );
}

const TYPES = [
  { value: 'SI', label: 'SI (시스템 통합)' },
  { value: 'SAP', label: 'SAP ERP 구축/운영' },
  { value: 'cloud', label: '클라우드 전환/구축' },
  { value: 'consulting', label: 'IT 컨설팅' },
  { value: 'maintenance', label: '유지보수/운영' },
  { value: 'ai', label: 'AI/빅데이터' },
  { value: 'mobile', label: '모바일/웹 앱 개발' },
  { value: 'security', label: '보안 컨설팅/구축' },
];

function IssueAnalysis({ capture, setCapture, onGenerate }) {
  const st = capture.issue_stakeholders || [];
  const ROLES = ['결정자','영향자','사용자','게이트키퍼'];

  const addStakeholder = () => {
    setCapture({...capture, issue_stakeholders: [...st, {role:'영향자',name:'',title:'',power:3,issues:[{issue:'',importance:3}]}]});
  };
  const removeStakeholder = (idx) => {
    setCapture({...capture, issue_stakeholders: st.filter((_,i) => i !== idx)});
  };
  const updateSH = (idx, field, val) => {
    const arr = [...st]; arr[idx] = {...arr[idx], [field]: val};
    setCapture({...capture, issue_stakeholders: arr});
  };
  const addIssue = (shIdx) => {
    const arr = [...st]; arr[shIdx] = {...arr[shIdx], issues: [...arr[shIdx].issues, {issue:'',importance:3}]};
    setCapture({...capture, issue_stakeholders: arr});
  };
  const removeIssue = (shIdx, isIdx) => {
    const arr = [...st]; arr[shIdx] = {...arr[shIdx], issues: arr[shIdx].issues.filter((_,i) => i !== isIdx)};
    setCapture({...capture, issue_stakeholders: arr});
  };
  const updateIssue = (shIdx, isIdx, field, val) => {
    const arr = [...st]; const issues = [...arr[shIdx].issues]; issues[isIdx] = {...issues[isIdx], [field]: val};
    arr[shIdx] = {...arr[shIdx], issues}; setCapture({...capture, issue_stakeholders: arr});
  };

  // 파워 등급 계산 및 이슈별 집계
  const allIssueRows = [];
  st.forEach(sh => {
    sh.issues.forEach(is => {
      if (is.issue) allIssueRows.push({ name:sh.name, role:sh.role, title:sh.title, power:Number(sh.power)||0, issue:is.issue, importance:Number(is.importance)||0, grade:(Number(sh.power)||0)*(Number(is.importance)||0) });
    });
  });

  const issueMap = {};
  allIssueRows.forEach(r => {
    if (!issueMap[r.issue]) issueMap[r.issue] = {total:0, people:[]};
    issueMap[r.issue].total += r.grade;
    issueMap[r.issue].people.push(r.name+'('+r.grade+')');
  });
  const sortedIssues = Object.entries(issueMap).sort((a,b) => b[1].total - a[1].total);
  const totalPower = sortedIssues.reduce((s,e) => s + e[1].total, 0) || 1;

  return (
    <div style={{background:'white',borderRadius:8,border:'1px solid #ddd',padding:20}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
        <div>
          <h3 style={{margin:0,fontSize:17,color:'#c62828'}}>이슈분석표</h3>
          <p style={{fontSize:12,color:'#888',margin:'4px 0 0'}}>핵심관련자별 영향력 × 이슈 중요도 = 파워 등급 자동 계산</p>
        </div>
        <button onClick={onGenerate} style={{padding:'8px 16px',background:'#1565c0',color:'white',border:'none',borderRadius:6,cursor:'pointer',fontSize:13,fontWeight:'bold'}}>제안서 생성하기</button>
      </div>

      {/* 관련자 입력 */}
      <div style={{marginBottom:20}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
          <span style={{fontSize:14,fontWeight:'bold',color:'#333'}}>핵심관련자 ({st.length}명)</span>
          <button onClick={addStakeholder} style={{padding:'6px 14px',background:'#c62828',color:'white',border:'none',borderRadius:6,cursor:'pointer',fontSize:12,fontWeight:'bold'}}>+ 관련자 추가</button>
        </div>

        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill, minmax(420px, 1fr))',gap:12}}>
          {st.map((sh, si) => (
            <div key={si} style={{background:'#fff8f8',borderRadius:8,border:'1px solid #ffcdd2',padding:14,overflow:'hidden'}}>
              {/* 1행: 역할, 성명, 직책 */}
              <div style={{display:'flex',gap:6,marginBottom:6,alignItems:'center',flexWrap:'wrap'}}>
                <select value={sh.role} onChange={e => updateSH(si,'role',e.target.value)}
                  style={{padding:5,borderRadius:4,border:'1px solid #ddd',fontSize:12,fontWeight:'bold',color:'#c62828',minWidth:70}}>
                  {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
                </select>
                <input value={sh.name} onChange={e => updateSH(si,'name',e.target.value)}
                  placeholder="성명" style={{width:80,padding:5,borderRadius:4,border:'1px solid #ddd',fontSize:12}} />
                <input value={sh.title} onChange={e => updateSH(si,'title',e.target.value)}
                  placeholder="직책" style={{width:80,padding:5,borderRadius:4,border:'1px solid #ddd',fontSize:12}} />
                <span style={{fontSize:10,color:'#888',marginLeft:'auto'}}>영향력</span>
                <select value={sh.power} onChange={e => updateSH(si,'power',e.target.value)}
                  style={{padding:3,borderRadius:4,border:'1px solid #ddd',fontSize:12,fontWeight:'bold',color:'#c62828',width:40}}>
                  {[1,2,3,4,5].map(n => <option key={n} value={n}>{n}</option>)}
                </select>
                <button onClick={() => removeStakeholder(si)} style={{background:'#ffebee',border:'none',color:'#c62828',borderRadius:4,cursor:'pointer',fontSize:11,padding:'3px 6px'}}>X</button>
              </div>

              {/* 이슈 목록 */}
              {sh.issues.map((is, ii) => {
                const grade = (Number(sh.power)||0) * (Number(is.importance)||0);
                return (
                  <div key={ii} style={{display:'flex',gap:4,marginBottom:4,alignItems:'center'}}>
                    <input value={is.issue} onChange={e => updateIssue(si,ii,'issue',e.target.value)}
                      placeholder="핵심이슈" style={{flex:1,minWidth:0,padding:4,borderRadius:4,border:'1px solid #eee',fontSize:12,boxSizing:'border-box'}} />
                    <span style={{fontSize:10,color:'#888',flexShrink:0}}>중요도</span>
                    <select value={is.importance} onChange={e => updateIssue(si,ii,'importance',e.target.value)}
                      style={{padding:2,borderRadius:4,border:'1px solid #ddd',fontSize:12,width:40,flexShrink:0}}>
                      {[1,2,3,4,5].map(n => <option key={n} value={n}>{n}</option>)}
                    </select>
                    <span style={{fontSize:12,fontWeight:'bold',color:grade>=20?'#c62828':grade>=10?'#e67700':'#888',minWidth:24,textAlign:'right',flexShrink:0}}>{grade}</span>
                    <button onClick={() => removeIssue(si,ii)} style={{background:'none',border:'none',color:'#ccc',cursor:'pointer',fontSize:12,flexShrink:0}}>-</button>
                  </div>
                );
              })}
              <button onClick={() => addIssue(si)} style={{width:'100%',padding:3,background:'#ffebee',border:'1px solid #ffcdd2',borderRadius:4,cursor:'pointer',fontSize:11,color:'#c62828',marginTop:4}}>+ 이슈 추가</button>
            </div>
          ))}
        </div>
      </div>

      {/* 자동 집계 결과 */}
      {sortedIssues.length > 0 && (
        <div>
          <h4 style={{fontSize:14,fontWeight:'bold',color:'#333',marginBottom:10}}>이슈별 파워 집계 (자동 계산)</h4>
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
            <thead>
              <tr style={{background:'#ffebee'}}>
                <th style={{padding:'8px 10px',textAlign:'left',borderBottom:'2px solid #c62828',color:'#c62828'}}>순위</th>
                <th style={{padding:'8px 10px',textAlign:'left',borderBottom:'2px solid #c62828',color:'#c62828'}}>주요 이슈</th>
                <th style={{padding:'8px 10px',textAlign:'center',borderBottom:'2px solid #c62828',color:'#c62828'}}>파워 합계</th>
                <th style={{padding:'8px 10px',textAlign:'center',borderBottom:'2px solid #c62828',color:'#c62828'}}>비중</th>
                <th style={{padding:'8px 10px',textAlign:'left',borderBottom:'2px solid #c62828',color:'#c62828'}}>관련자</th>
              </tr>
            </thead>
            <tbody>
              {sortedIssues.map(([issue, data], i) => {
                const pct = Math.round((data.total / totalPower) * 100);
                return (
                  <tr key={i} style={{borderBottom:'1px solid #eee',background:i%2===0?'white':'#fafafa'}}>
                    <td style={{padding:'6px 10px',fontWeight:'bold',color:'#c62828'}}>{i+1}</td>
                    <td style={{padding:'6px 10px',fontWeight:'bold'}}>{issue}</td>
                    <td style={{padding:'6px 10px',textAlign:'center'}}>
                      <span style={{fontWeight:'bold',fontSize:15,color:data.total>=20?'#c62828':data.total>=10?'#e67700':'#333'}}>{data.total}</span>
                    </td>
                    <td style={{padding:'6px 10px',textAlign:'center'}}>
                      <div style={{display:'flex',alignItems:'center',gap:4,justifyContent:'center'}}>
                        <div style={{width:60,height:8,background:'#eee',borderRadius:4,overflow:'hidden'}}>
                          <div style={{height:'100%',background:pct>=30?'#c62828':pct>=15?'#e67700':'#999',width:pct+'%',borderRadius:4}} />
                        </div>
                        <span style={{fontSize:12,fontWeight:'bold'}}>{pct}%</span>
                      </div>
                    </td>
                    <td style={{padding:'6px 10px',fontSize:11,color:'#666'}}>{data.people.join(', ')}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <div style={{background:'#fff3e0',borderRadius:8,padding:12,fontSize:12,color:'#e67700',lineHeight:1.5,marginTop:16,textAlign:'center'}}>
            이슈분석표가 제안서 생성 시 자동 반영됩니다. 파워 비중이 높은 이슈가 제안서에서 더 강조됩니다.
          </div>
        </div>
      )}
    </div>
  );
}

function ProposalAgent() {
  const navigate = useNavigate();
  const [mode, setMode] = useState('create');
  const [inputTab, setInputTab] = useState('manual');
  const [form, setForm] = useState({ project_name:'', client:'', proposal_type:'SI', scope:'', budget:'', duration:'', tech_stack:'', team_size:'', additional:'' });
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [proposals, setProposals] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [refineInput, setRefineInput] = useState('');
  const [refining, setRefining] = useState(false);
  const [saveMsg, setSaveMsg] = useState('');
  // RFP
  const [rfpText, setRfpText] = useState('');
  const [rfpFile, setRfpFile] = useState(null);
  const [rfpAnalysis, setRfpAnalysis] = useState(null);
  const [rfpLoading, setRfpLoading] = useState(false);
  const [rfpFilename, setRfpFilename] = useState('');
  // Capture Plan
  const [capture, setCapture] = useState({
    // 1. 개요 (구조화)
    cp_project_name: '',
    cp_rfp_date: '', cp_submit_date: '', cp_pt_date: '',
    cp_org_structure: '',
    cp_project_phase: '',
    cp_budget: '',
    cp_eval_count: '',
    cp_eval_groups: '',
    cp_eval_leader: '',
    cp_competitors_summary: '',
    // 2. 과제분석 세분화
    project_desc: '',
    official_requirements: '',
    customer_goals: '',
    unofficial_requirements: '',
    // 3. 고객 조직정보 세분화
    customer_org_chart: '',
    key_stakeholders: '',
    eval_committee_info: '',
    // 4. 고객 주요이슈 세분화
    customer_issues_table: '',
    // 5. 경쟁사 정보 세분화
    competitor_overview: '',
    competitor_sales: '',
    competitor_tech: '',
    competitor_solutions: '',
    competitor_strategy: '',
    // 6. 자사 정보 세분화
    our_overall: '',
    // 이슈분석표
    issue_stakeholders: [
      {role:'결정자',name:'',title:'',power:3,issues:[{issue:'',importance:3}]},
    ],
    // 7. 제안전략 4분면
    str_our_strength: '',
    str_our_weakness: '',
    str_comp_strength: '',
    str_comp_weakness: '',
    our_sales: '',
    our_tech: '',
    our_solutions: '',
    our_experience: '',
    // 3~7
    project_analysis: '',
    customer_org: '',
    customer_issues: '',
    competitors: '',
    our_strengths: '',
    proposal_strategy: '',
  });

  useEffect(() => { loadProposals(); }, []);

  const loadProposals = async () => {
    try { const res = await fetch(`${API}/proposal/list`); const d = await res.json(); setProposals(d.proposals || []); } catch(e) {}
  };

  const uploadRfp = async () => {
    if (!rfpFile) return alert('RFP 파일을 선택해주세요.');
    setRfpLoading(true); setRfpAnalysis(null);
    const formData = new FormData();
    formData.append('file', rfpFile);
    try {
      const res = await fetch(`${API}/proposal/upload-rfp`, { method:'POST', body: formData });
      const d = await res.json();
      if (d.rfp_text) {
        setRfpText(d.rfp_text);
        setRfpFilename(d.filename);
        // 자동 분석
        const res2 = await fetch(`${API}/proposal/analyze-rfp`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({rfp_text: d.rfp_text}) });
        const d2 = await res2.json();
        if (d2.analysis) {
          setRfpAnalysis(d2.analysis);
          // 폼에 자동 채우기
          const a = d2.analysis;
          setForm(f => ({
            ...f,
            project_name: a.project_name || f.project_name,
            client: a.client || f.client,
            proposal_type: a.proposal_type || f.proposal_type,
            scope: a.scope || f.scope,
            budget: a.budget || f.budget,
            duration: a.duration || f.duration,
            tech_stack: a.tech_stack || f.tech_stack,
            team_size: a.team_size || f.team_size,
          }));
        }
      } else { alert(d.error || '업로드 실패'); }
    } catch(e) { alert('업로드 실패'); }
    setRfpLoading(false);
  };

  const analyzeRfpText = async () => {
    if (!rfpText.trim()) return alert('RFP 내용을 입력해주세요.');
    setRfpLoading(true); setRfpAnalysis(null);
    try {
      const res = await fetch(`${API}/proposal/analyze-rfp`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({rfp_text: rfpText}) });
      const d = await res.json();
      if (d.analysis) {
        setRfpAnalysis(d.analysis);
        const a = d.analysis;
        setForm(f => ({...f, project_name:a.project_name||f.project_name, client:a.client||f.client,
          proposal_type:a.proposal_type||f.proposal_type, scope:a.scope||f.scope,
          budget:a.budget||f.budget, duration:a.duration||f.duration,
          tech_stack:a.tech_stack||f.tech_stack, team_size:a.team_size||f.team_size}));
      }
    } catch(e) {}
    setRfpLoading(false);
  };

  const generate = async () => {
    if (!form.project_name.trim()) return alert('프로젝트명을 입력해주세요.');
    setLoading(true); setContent('');
    try {
      const payload = {...form, rfp_text: rfpText,
        key_requirements: rfpAnalysis?.key_requirements || [],
        evaluation_criteria: rfpAnalysis?.evaluation_criteria || [],
        special_conditions: rfpAnalysis?.special_conditions || [],
        capture_plan: capture };
      const res = await fetch(`${API}/proposal/generate`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload) });
      const d = await res.json();
      setContent(d.content || d.error || '');
    } catch(e) { setContent('생성 실패'); }
    setLoading(false);
  };

  const save = async () => {
    if (!content) return;
    try {
      const res = await fetch(`${API}/proposal/save`, { method:'POST', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ id:selectedId, title:form.project_name||'제안서', client:form.client, proposal_type:form.proposal_type, content, status:'draft' })});
      const d = await res.json();
      setSaveMsg(d.message); setSelectedId(d.id);
      setTimeout(() => setSaveMsg(''), 2000);
      loadProposals();
    } catch(e) { setSaveMsg('저장 실패'); }
  };

  const loadProposal = async (id) => {
    try {
      const res = await fetch(`${API}/proposal/${id}`);
      const d = await res.json();
      setContent(d.content || '');
      setSelectedId(d.id);
      setForm(f => ({...f, project_name: d.title, client: d.client, proposal_type: d.type}));
      setMode('create');
    } catch(e) {}
  };

  const deleteProposal = async (id) => {
    if (!window.confirm('삭제하시겠습니까?')) return;
    await fetch(`${API}/proposal/${id}`, {method:'DELETE'});
    if (selectedId === id) { setSelectedId(null); setContent(''); }
    loadProposals();
  };

  const refine = async () => {
    if (!refineInput.trim() || !content) return;
    setRefining(true);
    try {
      const res = await fetch(`${API}/proposal/refine`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({content, instruction:refineInput}) });
      const d = await res.json();
      if (d.content) { setContent(d.content); setRefineInput(''); }
    } catch(e) {}
    setRefining(false);
  };

  const download = async (format) => {
    try {
      const res = await fetch(`${API}/prepare-download`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({answer:content, question:form.project_name||'제안서'})});
      const prepData = await res.json(); if (prepData.file_id) { window.open(`${API}/get-download/${prepData.file_id}`, '_self'); return; }
    } catch(e) { alert('다운로드 실패'); }
  };

  const sendMail = async () => {
    const to = prompt('수신자 이메일을 입력하세요 (여러 명은 쉼표로 구분):');
    if (!to) return;
    try {
      const res = await fetch(`${API}/send-email`, { method:'POST', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ to, subject:'[제안서] ' + (form.project_name||''), question:form.project_name, answer:content })});
      const d = await res.json();
      alert(d.message || d.error);
    } catch(e) { alert('전송 실패'); }
  };

  const md = {
    h1: ({children}) => <h1 style={{fontSize:20,color:'#0d47a1',borderBottom:'2px solid #e3f2fd',paddingBottom:6,marginTop:20}}>{children}</h1>,
    h2: ({children}) => <h2 style={{fontSize:17,color:'#1565c0',marginTop:18}}>{children}</h2>,
    h3: ({children}) => <h3 style={{fontSize:15,color:'#1976d2',borderLeft:'4px solid #1976d2',paddingLeft:10,marginTop:16}}>{children}</h3>,
    strong: ({children}) => <strong style={{color:'#0d47a1'}}>{children}</strong>,
    p: ({children}) => <p style={{margin:'6px 0',lineHeight:1.7}}>{children}</p>,
    ul: ({children}) => <ul style={{paddingLeft:20,margin:'6px 0'}}>{children}</ul>,
    ol: ({children}) => <ol style={{paddingLeft:20,margin:'6px 0'}}>{children}</ol>,
    li: ({children}) => <li style={{marginBottom:3}}>{children}</li>,
    table: ({children}) => <div style={{overflowX:'auto',margin:'10px 0'}}><table style={{borderCollapse:'collapse',width:'100%',fontSize:13,border:'1px solid #bbdefb'}}>{children}</table></div>,
    thead: ({children}) => <thead style={{background:'#e3f2fd'}}>{children}</thead>,
    th: ({children}) => <th style={{border:'1px solid #90caf9',padding:'8px 10px',background:'#e3f2fd',textAlign:'left',fontWeight:'bold',color:'#0d47a1'}}>{children}</th>,
    td: ({children}) => <td style={{border:'1px solid #bbdefb',padding:'7px 10px'}}>{children}</td>,
  };

  return (
    <div style={{minHeight:'100vh',background:'#f5f7fa'}}>
      <div style={{background:'linear-gradient(135deg,#0d47a1,#1565c0,#1976d2)',padding:'14px 20px',display:'flex',alignItems:'center',gap:16,boxShadow:'0 2px 12px rgba(13,71,161,0.3)'}}>
        <button onClick={() => navigate('/')} style={{background:'rgba(255,255,255,0.15)',border:'none',color:'white',width:36,height:36,borderRadius:8,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12 4l-6 6 6 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <div style={{flex:1}}>
          <div style={{color:'white',fontSize:18,fontWeight:'bold'}}>AI 제안서 생성</div>
          <div style={{color:'rgba(255,255,255,0.8)',fontSize:12}}>프로젝트 정보 입력 → AI가 전문 제안서 자동 작성</div>
        </div>
      </div>

      <div style={{maxWidth:1200,margin:'24px auto',padding:'0 20px 40px',display:'grid',gridTemplateColumns: (mode === 'capture' || mode === 'issue') ? '1fr' : '320px 1fr',gap:20}}>
        {/* 좌측: 입력 + 저장 목록 */}
        <div style={{display:'flex',flexDirection:'column',gap:16}}>
          {/* 탭 */}
          <div style={{display:'flex',background:'#e0e0e0',borderRadius:8,overflow:'hidden'}}>
            <button onClick={() => setMode('create')} style={{flex:1,padding:8,border:'none',cursor:'pointer',fontSize:11,fontWeight:'bold',background:mode==='create'?'#1565c0':'transparent',color:mode==='create'?'white':'#555'}}>제안서 작성</button>
            <button onClick={() => setMode('capture')} style={{flex:1,padding:8,border:'none',cursor:'pointer',fontSize:11,fontWeight:'bold',background:mode==='capture'?'#e67700':'transparent',color:mode==='capture'?'white':'#555'}}>Capture Plan</button>
            <button onClick={() => setMode('issue')} style={{flex:1,padding:8,border:'none',cursor:'pointer',fontSize:11,fontWeight:'bold',background:mode==='issue'?'#c62828':'transparent',color:mode==='issue'?'white':'#555'}}>이슈분석표</button>
            <button onClick={() => setMode('list')} style={{flex:1,padding:8,border:'none',cursor:'pointer',fontSize:11,fontWeight:'bold',background:mode==='list'?'#1565c0':'transparent',color:mode==='list'?'white':'#555'}}>저장 ({proposals.length})</button>
          </div>

          {mode === 'create' ? (
            <div style={{background:'white',borderRadius:8,border:'1px solid #ddd',padding:16}}>
              {/* RFP / 수동 입력 탭 */}
              <div style={{display:'flex',background:'#e8eaf6',borderRadius:6,overflow:'hidden',marginBottom:12}}>
                <button onClick={() => setInputTab('manual')} style={{flex:1,padding:8,border:'none',cursor:'pointer',fontSize:12,fontWeight:'bold',background:inputTab==='manual'?'#1565c0':'transparent',color:inputTab==='manual'?'white':'#555'}}>직접 입력</button>
                <button onClick={() => setInputTab('rfp')} style={{flex:1,padding:8,border:'none',cursor:'pointer',fontSize:12,fontWeight:'bold',background:inputTab==='rfp'?'#1565c0':'transparent',color:inputTab==='rfp'?'white':'#555'}}>RFP 입력</button>
              </div>

              {/* RFP 입력 탭 */}
              {inputTab === 'rfp' && (
                <div style={{marginBottom:16}}>
                  <div style={{background:'#e3f2fd',borderRadius:6,padding:12,marginBottom:10,fontSize:12,color:'#0d47a1',lineHeight:1.5}}>
                    RFP(제안요청서)를 업로드하거나 붙여넣으면 AI가 자동으로 분석하여 프로젝트 정보를 추출하고 맞춤 제안서를 생성합니다.
                  </div>

                  {/* 파일 업로드 */}
                  <div style={{marginBottom:10}}>
                    <label style={{fontSize:11,color:'#888',display:'block',marginBottom:3}}>RFP 파일 업로드</label>
                    <div style={{display:'flex',gap:6}}>
                      <input type="file" accept=".pdf,.docx,.xlsx,.txt,.png,.jpg,.jpeg" onChange={e => setRfpFile(e.target.files[0])} style={{flex:1,fontSize:11}} />
                      <button onClick={uploadRfp} disabled={rfpLoading||!rfpFile}
                        style={{padding:'6px 12px',background:rfpLoading?'#ccc':'#1565c0',color:'white',border:'none',borderRadius:4,cursor:'pointer',fontSize:11,fontWeight:'bold',whiteSpace:'nowrap'}}>
                        {rfpLoading ? '분석중...' : '업로드+분석'}
                      </button>
                    </div>
                    {rfpFilename && <span style={{fontSize:10,color:'#2e7d32',marginTop:2,display:'block'}}>{rfpFilename} 업로드됨</span>}
                  </div>

                  {/* 텍스트 직접 입력 */}
                  <div style={{marginBottom:10}}>
                    <label style={{fontSize:11,color:'#888',display:'block',marginBottom:3}}>또는 RFP 내용 직접 붙여넣기</label>
                    <textarea value={rfpText} onChange={e => setRfpText(e.target.value)}
                      rows={6}
                      style={{width:'100%',padding:8,borderRadius:4,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical'}} />
                    <button onClick={analyzeRfpText} disabled={rfpLoading||!rfpText.trim()}
                      style={{marginTop:4,padding:'6px 12px',background:rfpLoading?'#ccc':'#e67700',color:'white',border:'none',borderRadius:4,cursor:'pointer',fontSize:11,fontWeight:'bold'}}>
                      {rfpLoading ? '분석중...' : 'RFP 텍스트 분석'}
                    </button>
                  </div>

                  {/* 분석 결과 */}
                  {rfpAnalysis && (
                    <div style={{background:'#f1f8e9',borderRadius:6,padding:12,border:'1px solid #c8e6c9'}}>
                      <div style={{fontSize:12,fontWeight:'bold',color:'#2e7d32',marginBottom:8}}>RFP 분석 결과 (자동 추출)</div>
                      {rfpAnalysis.summary && <div style={{fontSize:11,color:'#555',marginBottom:8,lineHeight:1.5}}>{rfpAnalysis.summary}</div>}
                      {rfpAnalysis.key_requirements?.length > 0 && (
                        <div style={{marginBottom:6}}>
                          <div style={{fontSize:11,fontWeight:'bold',color:'#1b5e20'}}>핵심 요구사항</div>
                          {rfpAnalysis.key_requirements.map((r,i) => (
                            <div key={i} style={{fontSize:10,color:'#333',padding:'2px 0'}}>- {r}</div>
                          ))}
                        </div>
                      )}
                      {rfpAnalysis.evaluation_criteria?.length > 0 && (
                        <div style={{marginBottom:6}}>
                          <div style={{fontSize:11,fontWeight:'bold',color:'#0d47a1'}}>평가 기준</div>
                          {rfpAnalysis.evaluation_criteria.map((r,i) => (
                            <div key={i} style={{fontSize:10,color:'#333',padding:'2px 0'}}>- {r}</div>
                          ))}
                        </div>
                      )}
                      {rfpAnalysis.submission_deadline && (
                        <div style={{fontSize:11,color:'#c62828',fontWeight:'bold',marginTop:4}}>제출 기한: {rfpAnalysis.submission_deadline}</div>
                      )}
                      <div style={{marginTop:8,fontSize:11,color:'#2e7d32',fontStyle:'italic'}}>아래 프로젝트 정보가 자동으로 채워졌습니다.</div>
                    </div>
                  )}
                </div>
              )}

              <h3 style={{margin:'0 0 12px',fontSize:15,color:'#0d47a1'}}>프로젝트 정보 {rfpAnalysis ? '(RFP에서 추출)' : ''}</h3>
              {[
                {key:'project_name',label:'프로젝트명 *',ph:'예: OO기업 ERP 구축 프로젝트'},
                {key:'client',label:'고객사',ph:'예: 삼성전자'},
              ].map(f => (
                <div key={f.key} style={{marginBottom:10}}>
                  <label style={{fontSize:11,color:'#888',display:'block',marginBottom:3}}>{f.label}</label>
                  <input value={form[f.key]} onChange={e => setForm({...form,[f.key]:e.target.value})} placeholder={f.ph}
                    style={{width:'100%',padding:8,borderRadius:4,border:'1px solid #ddd',fontSize:13,boxSizing:'border-box'}} />
                </div>
              ))}
              <div style={{marginBottom:10}}>
                <label style={{fontSize:11,color:'#888',display:'block',marginBottom:3}}>제안 유형</label>
                <select value={form.proposal_type} onChange={e => setForm({...form,proposal_type:e.target.value})}
                  style={{width:'100%',padding:8,borderRadius:4,border:'1px solid #ddd',fontSize:13}}>
                  {TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                </select>
              </div>
              {[
                {key:'scope',label:'프로젝트 범위',ph:'예: ERP FI/CO/MM/SD 모듈 구축'},
                {key:'duration',label:'프로젝트 기간',ph:'예: 2026.04 ~ 2026.12 (9개월)'},
                {key:'budget',label:'예상 예산',ph:'예: 5억원'},
                {key:'tech_stack',label:'기술 스택',ph:'예: SAP S/4HANA, Fiori, ABAP'},
                {key:'team_size',label:'투입 인원',ph:'예: PM 1명, PL 2명, 개발자 5명'},
              ].map(f => (
                <div key={f.key} style={{marginBottom:10}}>
                  <label style={{fontSize:11,color:'#888',display:'block',marginBottom:3}}>{f.label}</label>
                  <input value={form[f.key]} onChange={e => setForm({...form,[f.key]:e.target.value})} placeholder={f.ph}
                    style={{width:'100%',padding:8,borderRadius:4,border:'1px solid #ddd',fontSize:13,boxSizing:'border-box'}} />
                </div>
              ))}
              <div style={{marginBottom:12}}>
                <label style={{fontSize:11,color:'#888',display:'block',marginBottom:3}}>추가 요청</label>
                <textarea value={form.additional} onChange={e => setForm({...form,additional:e.target.value})}
                  rows={3}
                  style={{width:'100%',padding:8,borderRadius:4,border:'1px solid #ddd',fontSize:13,boxSizing:'border-box',resize:'vertical'}} />
              </div>
              <button onClick={generate} disabled={loading}
                style={{width:'100%',padding:'12px',background:loading?'#ccc':'linear-gradient(135deg,#0d47a1,#1976d2)',color:'white',border:'none',borderRadius:6,cursor:'pointer',fontSize:15,fontWeight:'bold'}}>
                {loading ? 'AI 제안서 생성 중...' : 'AI 제안서 생성'}
              </button>
            </div>
          ) : mode === 'capture' ? (
            <div style={{background:'white',borderRadius:8,border:'1px solid #ddd',padding:20}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
                <div>
                  <h3 style={{margin:0,fontSize:17,color:'#e67700'}}>Capture Plan (영업 정보)</h3>
                  <p style={{fontSize:12,color:'#888',margin:'4px 0 0'}}>영업 단계에서 수집한 정보를 입력하면 AI가 제안서에 반영합니다.</p>
                </div>
                <button onClick={() => setMode('create')} style={{padding:'8px 16px',background:'#1565c0',color:'white',border:'none',borderRadius:6,cursor:'pointer',fontSize:13,fontWeight:'bold',whiteSpace:'nowrap'}}>제안서 생성하기</button>
              </div>

              {/* 2열 그리드 레이아웃 */}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
                {/* 왼쪽: 1. 개요 */}
                <div style={{background:'#fff8f0',borderRadius:8,padding:16,border:'1px solid #ffe0b2'}}>
                  <div style={{fontSize:14,fontWeight:'bold',color:'#e67700',marginBottom:12}}>1. Capture Plan 개요</div>
                  {[
                    {key:'cp_project_name', label:'과제(사업명)', tip:'입찰/수주 대상 사업의 공식 명칭\n예: 완소병원 IT 헬프데스크 아웃소싱'},
                    {key:'cp_project_phase', label:'과제 단계', tip:'신규/재계약/확장 등 사업 단계\n예: IT 헬프데스크 운영 1차 사업'},
                    {key:'cp_budget', label:'예산', tip:'고객이 책정한 예상 예산\n예: 5억원, 미정 시 빈칸'},
                  ].map(f => (
                    <div key={f.key} style={{marginBottom:10}}>
                      <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>{f.label}<HelpTip text={f.tip} /></label>
                      <input value={capture[f.key]} onChange={e => setCapture({...capture,[f.key]:e.target.value})}
                        style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:13,boxSizing:'border-box'}} />
                    </div>
                  ))}
                  <div style={{marginBottom:10}}>
                    <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>예정 일정</label>
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:8}}>
                      {[{key:'cp_rfp_date',label:'RFP 공고일'},{key:'cp_submit_date',label:'제출일'},{key:'cp_pt_date',label:'PT 발표일'}].map(d => (
                        <div key={d.key}>
                          <div style={{fontSize:11,color:'#999',marginBottom:2}}>{d.label}</div>
                          <input type="date" value={capture[d.key]} onChange={e => setCapture({...capture,[d.key]:e.target.value})}
                            style={{width:'100%',padding:6,borderRadius:4,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box'}} />
                        </div>
                      ))}
                    </div>
                  </div>
                  <div style={{marginBottom:10}}>
                    <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>고객 조직 구조<HelpTip text={"고객의 의사결정 조직 구조\n예: 이사회(설립자, 외부이사)\n→ CEO(나존중) → CFO(이결제)\n→ IT이사(전산원)"} /></label>
                    <textarea value={capture.cp_org_structure} onChange={e => setCapture({...capture,cp_org_structure:e.target.value})}
                      rows={2}
                      style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:13,boxSizing:'border-box',resize:'vertical'}} />
                  </div>
                  <div style={{marginBottom:10}}>
                    <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>예상 경쟁사<HelpTip text={"이번 입찰에 참여할 것으로\n예상되는 경쟁 업체\n예: 빅4, 아웃소싱(주), 고객 자체 솔루션"} /></label>
                    <input value={capture.cp_competitors_summary} onChange={e => setCapture({...capture,cp_competitors_summary:e.target.value})}
                      style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:13,boxSizing:'border-box'}} />
                  </div>
                </div>

                {/* 오른쪽: 평가위원 정보 */}
                <div style={{background:'#f0f4ff',borderRadius:8,padding:16,border:'1px solid #bbdefb'}}>
                  <div style={{fontSize:14,fontWeight:'bold',color:'#1565c0',marginBottom:12}}>평가위원 정보</div>
                  <div style={{marginBottom:10}}>
                    <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>예상 인원<HelpTip text={"제안 평가에 참여할 것으로\n예상되는 평가위원 수\n예: 10명"} /></label>
                    <input value={capture.cp_eval_count} onChange={e => setCapture({...capture,cp_eval_count:e.target.value})}
                      style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:13,boxSizing:'border-box'}} />
                  </div>
                  <div style={{marginBottom:10}}>
                    <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>참여 그룹<HelpTip text={"평가위원의 소속 그룹별 인원\n예: 설립자 4명, 외부이사 3명\n최고경영자 1명, IT이사 1명"} /></label>
                    <textarea value={capture.cp_eval_groups} onChange={e => setCapture({...capture,cp_eval_groups:e.target.value})}
                      rows={3}
                      style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:13,boxSizing:'border-box',resize:'vertical'}} />
                  </div>
                  <div style={{marginBottom:10}}>
                    <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>예상 주도 그룹 / 역할<HelpTip text={"평가를 주도하는 그룹과 역할\n누가 RFP를 쓰는지, 누가 추천하는지\n누가 최종 결정하는지\n예: 전산원→RFP작성, 이결제→추천\n나존중→최종 승인"} /></label>
                    <textarea value={capture.cp_eval_leader} onChange={e => setCapture({...capture,cp_eval_leader:e.target.value})}
                      rows={5}
                      style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:13,boxSizing:'border-box',resize:'vertical',lineHeight:1.5}} />
                  </div>
                </div>
              </div>

              {/* 2~7. 나머지 섹션 (2열) */}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginTop:16}}>
                {/* 2. 과제분석 - 세분화 */}
                <div style={{background:'#f1f8e9',borderRadius:8,padding:14,border:'1px solid #c8e6c9',gridColumn:'1/3'}}>
                  <div style={{fontSize:14,fontWeight:'bold',color:'#2e7d32',marginBottom:10}}>2. 과제(사업) 분석</div>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                    <div>
                      <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>과제 설명 (History 포함)<HelpTip text={"사업의 범위, 배경, 고객사 설명\n- 과제 범위: 어떤 서비스?\n- 사업 배경: 왜 이 사업이 생겼나?\n- 고객 배경: 규모, 업종, 현황"} /></label>
                      <textarea value={capture.project_desc} onChange={e => setCapture({...capture,project_desc:e.target.value})}
                        rows={5}
                        style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:13,boxSizing:'border-box',resize:'vertical',lineHeight:1.5,background:'white'}} />
                    </div>
                    <div>
                      <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>주요 요구사항 (공식)<HelpTip text={"RFP나 공고에 명시된 공식 요구사항\n- TCO 감소 증빙\n- 유사 수행 경험\n- 보안/역량 요건\n- 제안서 형식 요구"} /></label>
                      <textarea value={capture.official_requirements} onChange={e => setCapture({...capture,official_requirements:e.target.value})}
                        rows={5}
                        style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:13,boxSizing:'border-box',resize:'vertical',lineHeight:1.5,background:'white'}} />
                    </div>
                    <div>
                      <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>고객 공식 목표<HelpTip text={"고객이 공식적으로 발표한 경영 목표\n예: 수익성 향상\n확장을 위한 잉여금 확보\n핵심 사업 집중"} /></label>
                      <textarea value={capture.customer_goals} onChange={e => setCapture({...capture,customer_goals:e.target.value})}
                        rows={3}
                        style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:13,boxSizing:'border-box',resize:'vertical',lineHeight:1.5,background:'white'}} />
                    </div>
                    <div>
                      <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>기타 / 비공식 요구<HelpTip text={"공식 문서에 없지만 영업 과정에서\n파악한 비공식 요구사항\n예: 기존 직원 고용 승계\n적은 수 공급자 선호\n간결한 제안서 선호"} /></label>
                      <textarea value={capture.unofficial_requirements} onChange={e => setCapture({...capture,unofficial_requirements:e.target.value})}
                        rows={3}
                        style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:13,boxSizing:'border-box',resize:'vertical',lineHeight:1.5,background:'white'}} />
                    </div>
                  </div>
                </div>

                {[
                  {key:'_customer_org_section', label:'', ph:'', rows:0, color:'', bg:'', border:'', isCustom:true},
                  {key:'_customer_issues_section', label:'', ph:'', rows:0, color:'', bg:'', border:'', isCustom2:true},
                  {key:'_competitors_section', label:'', ph:'', rows:0, color:'', bg:'', border:'', isCustom3:true},
                  {key:'_our_strengths_section', label:'', ph:'', rows:0, color:'', bg:'', border:'', isCustom4:true},
                  {key:'_strategy_section', label:'', ph:'', rows:0, color:'', bg:'', border:'', isCustom5:true},
                ].map(f => {
                  if (f.isCustom5) {
                    return (
                      <div key="strategy_section" style={{background:'#e8eaf6',borderRadius:8,padding:14,border:'1px solid #9fa8da',gridColumn:'1/3'}}>
                        <div style={{fontSize:14,fontWeight:'bold',color:'#0d47a1',marginBottom:10}}>7. 제안전략 수립<HelpTip text={"SWOT 기반 4분면 전략\n① 자사 강점 극대화\n② 자사 약점 최소화\n③ 경쟁사 강점 무력화(Ghost)\n④ 경쟁사 약점 공격(Counter)\n이 전략이 제안서 전체에 반영됩니다"} /></div>
                        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                          <div style={{background:'#e8f5e9',borderRadius:6,padding:10,border:'1px solid #c8e6c9'}}>
                            <label style={{fontSize:12,fontWeight:'bold',color:'#2e7d32',display:'block',marginBottom:4}}>자사 강점 극대화</label>
                            <div style={{fontSize:10,color:'#888',marginBottom:4}}>강점(What) / 극대화 방법(How)</div>
                            <textarea value={capture.str_our_strength} onChange={e => setCapture({...capture,str_our_strength:e.target.value})}
                              rows={5}
                              style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white'}} />
                          </div>
                          <div style={{background:'#fff3e0',borderRadius:6,padding:10,border:'1px solid #ffe0b2'}}>
                            <label style={{fontSize:12,fontWeight:'bold',color:'#e67700',display:'block',marginBottom:4}}>자사 약점 최소화</label>
                            <div style={{fontSize:10,color:'#888',marginBottom:4}}>약점(What) / 최소화 방법(How)</div>
                            <textarea value={capture.str_our_weakness} onChange={e => setCapture({...capture,str_our_weakness:e.target.value})}
                              rows={5}
                              style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white'}} />
                          </div>
                          <div style={{background:'#ffebee',borderRadius:6,padding:10,border:'1px solid #ef9a9a'}}>
                            <label style={{fontSize:12,fontWeight:'bold',color:'#c62828',display:'block',marginBottom:4}}>경쟁사 강점 최소화 (Ghost)</label>
                            <div style={{fontSize:10,color:'#888',marginBottom:4}}>경쟁사 강점(What) / 최소화 방법(How)</div>
                            <textarea value={capture.str_comp_strength} onChange={e => setCapture({...capture,str_comp_strength:e.target.value})}
                              rows={5}
                              style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white'}} />
                          </div>
                          <div style={{background:'#f3e8fd',borderRadius:6,padding:10,border:'1px solid #ce93d8'}}>
                            <label style={{fontSize:12,fontWeight:'bold',color:'#4a148c',display:'block',marginBottom:4}}>경쟁사 약점 극대화 (Counter)</label>
                            <div style={{fontSize:10,color:'#888',marginBottom:4}}>경쟁사 약점(What) / 극대화 방법(How)</div>
                            <textarea value={capture.str_comp_weakness} onChange={e => setCapture({...capture,str_comp_weakness:e.target.value})}
                              rows={5}
                              style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white'}} />
                          </div>
                        </div>
                      </div>
                    );
                  }
                  if (f.isCustom4) {
                    return (
                      <div key="our_strengths_section" style={{background:'#fff8f0',borderRadius:8,padding:14,border:'1px solid #ffe0b2'}}>
                        <div style={{fontSize:13,fontWeight:'bold',color:'#e67700',marginBottom:8}}>6. 자사 정보<HelpTip text={"우리 회사의 경쟁력을 객관적으로 분석\n강점은 제안서에서 부각\n약점은 보완 방안과 함께 작성\n솔직할수록 AI가 좋은 전략 수립"} /></div>
                        <div style={{marginBottom:8}}>
                          <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>종합경쟁력 (경쟁사 대비)</label>
                          <textarea value={capture.our_overall} onChange={e => setCapture({...capture,our_overall:e.target.value})}
                            rows={2}
                            style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white'}} />
                        </div>
                        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:8}}>
                          <div>
                            <label style={{fontSize:11,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>영업경쟁력</label>
                            <textarea value={capture.our_sales} onChange={e => setCapture({...capture,our_sales:e.target.value})}
                              rows={3}
                              style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white'}} />
                          </div>
                          <div>
                            <label style={{fontSize:11,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>기술경쟁력</label>
                            <textarea value={capture.our_tech} onChange={e => setCapture({...capture,our_tech:e.target.value})}
                              rows={3}
                              style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white'}} />
                          </div>
                        </div>
                        <div style={{marginBottom:8}}>
                          <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>고객이슈별 자사 솔루션</label>
                          <textarea value={capture.our_solutions} onChange={e => setCapture({...capture,our_solutions:e.target.value})}
                            rows={5}
                            style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white',fontFamily:'monospace'}} />
                        </div>
                        <div>
                          <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>관련 경험 / 기술 확보</label>
                          <textarea value={capture.our_experience} onChange={e => setCapture({...capture,our_experience:e.target.value})}
                            rows={2}
                            style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white'}} />
                        </div>
                      </div>
                    );
                  }
                  if (f.isCustom3) {
                    return (
                      <div key="competitors_section" style={{background:'#f3e8fd',borderRadius:8,padding:14,border:'1px solid #ce93d8'}}>
                        <div style={{fontSize:13,fontWeight:'bold',color:'#4a148c',marginBottom:8}}>5. 경쟁사 정보<HelpTip text={"입찰 경쟁사를 분석하여\n영업/기술 경쟁력 비교\n고객이슈별 예상 솔루션 파악\n경쟁사 전략을 예측하여 Counter"} /></div>
                        <div style={{marginBottom:8}}>
                          <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>경쟁사명 / 종합경쟁력</label>
                          <textarea value={capture.competitor_overview} onChange={e => setCapture({...capture,competitor_overview:e.target.value})}
                            rows={2}
                            style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white'}} />
                        </div>
                        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:8}}>
                          <div>
                            <label style={{fontSize:11,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>영업경쟁력 (고객선호도)</label>
                            <textarea value={capture.competitor_sales} onChange={e => setCapture({...capture,competitor_sales:e.target.value})}
                              rows={3}
                              style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white'}} />
                          </div>
                          <div>
                            <label style={{fontSize:11,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>기술경쟁력</label>
                            <textarea value={capture.competitor_tech} onChange={e => setCapture({...capture,competitor_tech:e.target.value})}
                              rows={3}
                              style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white'}} />
                          </div>
                        </div>
                        <div style={{marginBottom:8}}>
                          <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>고객이슈별 경쟁사 예상 솔루션</label>
                          <textarea value={capture.competitor_solutions} onChange={e => setCapture({...capture,competitor_solutions:e.target.value})}
                            rows={4}
                            style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white',fontFamily:'monospace'}} />
                        </div>
                        <div>
                          <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>경쟁사 예상 전략 (Counter 전략 수립용)</label>
                          <textarea value={capture.competitor_strategy} onChange={e => setCapture({...capture,competitor_strategy:e.target.value})}
                            rows={4}
                            style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white'}} />
                        </div>
                      </div>
                    );
                  }
                  if (f.isCustom2) {
                    return (
                      <div key="customer_issues_section" style={{background:'#ffebee',borderRadius:8,padding:14,border:'1px solid #ef9a9a'}}>
                        <div style={{fontSize:13,fontWeight:'bold',color:'#c62828',marginBottom:8}}>4. 고객 조직의 주요 이슈<HelpTip text={"핵심관련자 영향력 × 이슈 중요도를\n종합하여 비중(%) 산출\n비중 높은 이슈 = 제안서에서 가장 강조\n#|이슈|비중(%)|관련자 형식으로 입력"} /></div>
                        <textarea value={capture.customer_issues_table} onChange={e => setCapture({...capture,customer_issues_table:e.target.value})}
                          rows={6}
                          style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.5,background:'white',fontFamily:'monospace'}} />
                      </div>
                    );
                  }
                  if (f.isCustom) {
                    // 3. 고객 조직정보 세분화
                    return (
                      <div key="customer_org_section" style={{background:'#e3f2fd',borderRadius:8,padding:14,border:'1px solid #90caf9'}}>
                        <div style={{fontSize:13,fontWeight:'bold',color:'#1565c0',marginBottom:8}}>3. 고객 조직정보</div>
                        <div style={{marginBottom:8}}>
                          <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>사업 주관 조직도<HelpTip text={"고객사 내부 조직 구조\n의사결정 라인을 파악하는 것이 핵심\n예: 이사회 → CEO → CFO → IT이사"} /></label>
                          <textarea value={capture.customer_org_chart} onChange={e => setCapture({...capture,customer_org_chart:e.target.value})}
                            rows={3}
                            style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white'}} />
                        </div>
                        <div style={{marginBottom:8}}>
                          <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>핵심관련자 관심이슈<HelpTip text={"3~6명의 핵심 의사결정자\n성명|직책|영향력(1~10)|관심이슈|중요도(1~10)\n영향력: 결정에 미치는 영향\n중요도: 해당 이슈의 중요성"} /></label>
                          <textarea value={capture.key_stakeholders} onChange={e => setCapture({...capture,key_stakeholders:e.target.value})}
                            rows={5}
                            style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white',fontFamily:'monospace'}} />
                        </div>
                        <div>
                          <label style={{fontSize:12,color:'#555',fontWeight:'bold',display:'block',marginBottom:3}}>평가위원회 정보<HelpTip text={"별도 평가위원회 존재 여부\n영향력 수준 (1~5)\n핵심관련자와의 관계"} /></label>
                          <textarea value={capture.eval_committee_info} onChange={e => setCapture({...capture,eval_committee_info:e.target.value})}
                            rows={2}
                            style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:12,boxSizing:'border-box',resize:'vertical',lineHeight:1.4,background:'white'}} />
                        </div>
                      </div>
                    );
                  }
                  return (
                  <div key={f.key} style={{background:f.bg,borderRadius:8,padding:14,border:'1px solid '+f.border}}>
                    <label style={{fontSize:13,fontWeight:'bold',color:f.color,display:'block',marginBottom:6}}>{f.label}</label>
                    <textarea value={capture[f.key]} onChange={e => setCapture({...capture, [f.key]: e.target.value})}
                      placeholder={f.ph} rows={f.rows}
                      style={{width:'100%',padding:8,borderRadius:6,border:'1px solid #ddd',fontSize:13,boxSizing:'border-box',resize:'vertical',lineHeight:1.5,background:'white'}} />
                  </div>
                  );
                })}
              </div>

              <div style={{background:'#fff3e0',borderRadius:8,padding:12,fontSize:12,color:'#e67700',lineHeight:1.5,marginTop:16,textAlign:'center'}}>
                Capture Plan 정보 입력 후 상단 <strong>"제안서 생성하기"</strong> 버튼 또는 "제안서 작성" 탭에서 생성하면 자동 반영됩니다.
              </div>
            </div>
          ) : mode === 'issue' ? (
            <IssueAnalysis capture={capture} setCapture={setCapture} onGenerate={() => setMode('create')} />
          ) : (
            <div style={{background:'white',borderRadius:8,border:'1px solid #ddd',padding:16,maxHeight:600,overflowY:'auto'}}>
              {proposals.length === 0 && <p style={{color:'#999',textAlign:'center',padding:20}}>저장된 제안서가 없습니다.</p>}
              {proposals.map(p => (
                <div key={p.id} onClick={() => loadProposal(p.id)}
                  style={{padding:12,marginBottom:8,borderRadius:8,cursor:'pointer',
                    border:selectedId===p.id?'2px solid #1565c0':'1px solid #e0e0e0',
                    background:selectedId===p.id?'#e3f2fd':'white'}}>
                  <div style={{fontWeight:'bold',fontSize:14,color:'#333'}}>{p.title}</div>
                  <div style={{display:'flex',gap:6,marginTop:4,flexWrap:'wrap'}}>
                    {p.client && <span style={{fontSize:10,padding:'1px 6px',background:'#e8f5e9',color:'#2e7d32',borderRadius:8}}>{p.client}</span>}
                    <span style={{fontSize:10,padding:'1px 6px',background:'#e3f2fd',color:'#1565c0',borderRadius:8}}>{TYPES.find(t=>t.value===p.type)?.label||p.type}</span>
                    <span style={{fontSize:10,padding:'1px 6px',background:p.status==='final'?'#e8f5e9':'#fff3e0',color:p.status==='final'?'#2e7d32':'#e67700',borderRadius:8}}>{p.status==='final'?'완료':'초안'}</span>
                  </div>
                  <div style={{fontSize:10,color:'#bbb',marginTop:4}}>{p.created_at}</div>
                  <button onClick={e => {e.stopPropagation(); deleteProposal(p.id);}}
                    style={{marginTop:6,padding:'2px 8px',background:'#ffebee',color:'#c62828',border:'1px solid #ef9a9a',borderRadius:4,cursor:'pointer',fontSize:10}}>삭제</button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* 우측: 제안서 내용 */}
        <div>
          {content ? (
            <div style={{background:'white',borderRadius:8,border:'1px solid #ddd',overflow:'hidden'}}>
              {/* 도구바 */}
              <div style={{padding:'10px 20px',background:'#fafafa',borderBottom:'1px solid #eee',display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:8}}>
                <span style={{fontWeight:'bold',color:'#0d47a1',fontSize:14}}>{form.project_name || '제안서'}</span>
                <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                  <button onClick={() => download('word')} style={{padding:'5px 12px',background:'#2b579a',color:'white',border:'none',borderRadius:4,cursor:'pointer',fontSize:12,fontWeight:'bold'}}>Word</button>
                  <button onClick={() => download('pdf')} style={{padding:'5px 12px',background:'#c62828',color:'white',border:'none',borderRadius:4,cursor:'pointer',fontSize:12,fontWeight:'bold'}}>PDF</button>
                  <button onClick={sendMail} style={{padding:'5px 12px',background:'#ea4335',color:'white',border:'none',borderRadius:4,cursor:'pointer',fontSize:12,fontWeight:'bold'}}>메일</button>
                  <button onClick={() => {navigator.clipboard.writeText(content);alert('복사됨');}} style={{padding:'5px 12px',background:'#666',color:'white',border:'none',borderRadius:4,cursor:'pointer',fontSize:12,fontWeight:'bold'}}>복사</button>
                  <button onClick={save} style={{padding:'5px 12px',background:'#2e7d32',color:'white',border:'none',borderRadius:4,cursor:'pointer',fontSize:12,fontWeight:'bold'}}>저장</button>
                  {saveMsg && <span style={{fontSize:12,color:'#2e7d32',alignSelf:'center'}}>{saveMsg}</span>}
                </div>
              </div>
              {/* 본문 */}
              <div style={{padding:24,fontSize:14,lineHeight:1.8}}>
                <ReactMarkdown remarkPlugins={[remarkGfm]} components={md}>{content}</ReactMarkdown>
              </div>
              {/* AI 보정 */}
              <div style={{padding:'14px 20px',borderTop:'1px solid #eee',background:'#fafafa'}}>
                <div style={{fontSize:13,fontWeight:'bold',color:'#333',marginBottom:8}}>AI 보정</div>
                <div style={{display:'flex',gap:8}}>
                  <input value={refineInput} onChange={e => setRefineInput(e.target.value)}
                    onKeyDown={e => {if(e.key==='Enter'&&!refining) refine();}}
                   
                    style={{flex:1,padding:10,borderRadius:6,border:'1px solid #ccc',fontSize:13}} />
                  <button onClick={refine} disabled={refining}
                    style={{padding:'10px 20px',background:refining?'#ccc':'#e67700',color:'white',border:'none',borderRadius:6,cursor:'pointer',fontSize:13,fontWeight:'bold',whiteSpace:'nowrap'}}>
                    {refining ? '보정중...' : 'AI 보정'}
                  </button>
                </div>
                <div style={{display:'flex',gap:6,marginTop:8,flexWrap:'wrap'}}>
                  {['견적을 더 상세하게','기대효과 수치를 추가','일정을 구체적으로','투입인력 보강','리스크 관리 강화','회사소개 보강'].map((q,i) => (
                    <button key={i} onClick={() => setRefineInput(q)}
                      style={{padding:'4px 10px',background:'white',border:'1px solid #ddd',borderRadius:12,cursor:'pointer',fontSize:11,color:'#666'}}>{q}</button>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <div style={{background:'white',borderRadius:8,border:'1px solid #ddd',padding:60,textAlign:'center'}}>
              <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                <rect x="12" y="4" width="34" height="44" rx="4" fill="#e3f2fd" stroke="#1565c0" strokeWidth="2"/>
                <path d="M20 16h18M20 24h18M20 32h12" stroke="#1565c0" strokeWidth="2" strokeLinecap="round"/>
                <circle cx="46" cy="46" r="14" fill="#1565c0"/>
                <path d="M42 46h8M46 42v8" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
              </svg>
              <h3 style={{color:'#333',marginTop:16}}>AI 제안서 생성</h3>
              <p style={{color:'#888',fontSize:14}}>왼쪽에서 프로젝트 정보를 입력하고 생성 버튼을 클릭하세요</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProposalAgent;
